import Vue from "vue";

export default {
    changeAnfallByIndex(state, anfallAndIndex) {
        Vue.set(state.anfaelle,anfallAndIndex.index, anfallAndIndex.anfall)
    },
    pushAnfallToAnfaelleList(state, anfall) {
        state.anfaelle.push(anfall)
    },
    deleteAnfall(state, index) {
        state.anfaelle.splice(index, 1)
    },
    changeDateOfAnfall(state, dateAndIndex) {
        state.anfaelle[dateAndIndex.index].datum = dateAndIndex.date
    }
}